import React, { useState } from "react";
import IamSidebar from "./iamSidebar/iamSidebar";
import IamViewer from "./iamViewer/iamViewer";
import './IAM.css';

const IAM = () => {
  const [selectedKey, setSelectedKey] = useState('1');

  return (
    <div className="IAM-container">
      <div style={{flex:1}}>
      <IamSidebar onMenuItemClick={setSelectedKey} />
      </div>
     
      <div style ={{flex:4,margin:"1rem"}}>
      <IamViewer selectedKey={selectedKey} />
      </div>
      
    </div>
  );
};

export default IAM;



/**
 * view (org, users, roles, permissions)
 * create (org, users, roles, permissions)
 * update (org, users, roles, permissions)
 * delete (org, users, roles, permissions)
 */